import appConf from '../app-conf'
const setup = appConf[process.env.REACT_APP_CLIENT]
const env = process.env.NODE_ENV
const config = {
  details: {
    env,
  },
  application: {
    cms: {
      api: {
        endpoints: {
          approvesetup: {
            headers: {
              'Content-Type': 'application/json',
            },
            url: setup.setup.api.cms.url[env] + '/mastersetups',
            // url: setup.setup.api.cms.url[env] + '/auth/local',
            method: 'PUT',
          },
          publishsetup: {
            headers: {
              'Content-Type': 'application/json',
            },
            url: setup.setup.api.cms.url[env] + '/mastersetups',
            // url: setup.setup.api.cms.url[env] + '/auth/local',
            method: 'POST',
          },
          publishupdatesetup: {
            headers: {
              'Content-Type': 'application/json',
            },
            url: setup.setup.api.cms.url[env] + '/mastersetups',
            // url: setup.setup.api.cms.url[env] + '/auth/local',
            method: 'PUT',
          },
          mastercontentsversions: {
            headers: {
              'Content-Type': 'application/json',
            },
            url: setup.setup.api.cms.url[env] + '/mastercontentsversions',
            // url: setup.setup.api.cms.url[env] + '/auth/local',
            method: 'GET',
          },
          updatecontentversion: {
            headers: {
              'Content-Type': 'application/json',
            },
            url: setup.setup.api.cms.url[env] + '/mastercontentsversions',
            // url: setup.setup.api.cms.url[env] + '/auth/local',
            method: 'PUT',
          },
          createmastercountrylang: {
            headers: {
              'Content-Type': 'application/json',
            },
            url: setup.setup.api.cms.url[env] + '/mastercountrylanguages',
            // url: setup.setup.api.cms.url[env] + '/auth/local',
            method: 'POST',
          },
        },
      },
    },
  },
  routes: {
    label: false,
    prefix: false,
  },
  env,
  setup,
}

export default config
